{
  "dashboard": {
    "logoAlt": "Smart Word Labs",
    "nav": {
      "adminPortal": "Admin portal",
      "enquiries": "Enquiries",
      "signOut": "Sign out"
    },
    "hero": {
      "adminBadge": "Admin account",
      "parentBadge": "Parent account",
      "greeting": "Hello{{name}}",
      "subtitle": "Lessons, billing, progress and tutor messages for every child in your family.",
      "addChild": "Add child",
      "form": {
        "childName": "Child's name",
        "age": "Age",
        "save": "Save"
      }
    },
    "plan": {
      "title": "Choose a monthly plan",
      "description": "Your free assessment is always included. A monthly plan unlocks live cohort lessons, homework feedback and CEFR progress reports.",
      "viewPlans": "View plans"
    },
    "studentMode": {
      "title": "Student Mode",
      "nextLesson": "Next lesson {{datetime}} — one click, no separate login for your child.",
      "noLesson": "No live lesson scheduled yet. Your next cohort session will appear here.",
      "joinClass": "Join Class"
    },
    "scheduling": {
      "title": "Lessons & scheduling",
      "bookAnother": "Book another assessment",
      "lessonFallback": "Lesson",
      "reschedule": "Reschedule",
      "rescheduleToast": {
        "title": "Reschedule requested",
        "description": "Your tutor will confirm a new slot by email."
      },
      "empty": {
        "title": "Book your free assessment",
        "description": "A 20-minute diagnostic call with Ms. Salma sets your child's CEFR level and learning plan. It's free and included with every account.",
        "cta": "Book free assessment"
      }
    },
    "billing": {
      "title": "Billing & subscription",
      "pastDue": "Your last payment failed. Update your card to keep lessons running.",
      "plan": "Plan",
      "noPlan": "No active plan",
      "status": "Status",
      "statusNone": "none",
      "accessEnds": "Access ends",
      "renewsOn": "Renews on",
      "childrenEnrolled": "Children enrolled",
      "manageSubscription": "Manage subscription",
      "opening": "Opening…",
      "choosePlan": "Choose a plan"
    },
    "progress": {
      "title": "Progress reports",
      "cefrLevel": "CEFR level",
      "awaitingAssessment": "Awaiting assessment",
      "lessonsCompleted": "Lessons completed",
      "homeworkReviewed": "Homework reviewed",
      "submitHomework": "Submit homework"
    },
    "homeworkFeedback": {
      "title": "Homework & tutor feedback",
      "empty": "No homework submissions yet."
    },
    "messages": {
      "title": "Messages from your tutor",
      "empty": "No messages yet. Your tutor will post lesson notes here after each session."
    },
    "toasts": {
      "childAdded": "Child profile added",
      "paymentReceived": {
        "title": "Payment received",
        "description": "Setting up your plan — this takes a few seconds."
      },
      "portalUnavailable": "Portal unavailable",
      "portalError": "Could not open the billing portal"
    }
  },
  "homework": {
    "backToDashboard": "Back to dashboard",
    "title": "Submit homework",
    "description": "Upload a reading recording and any worksheet pages. Files are stored privately and only visible to your tutor.",
    "form": {
      "lesson": "Lesson",
      "selectLesson": "Select a lesson",
      "lessonFallback": "Lesson",
      "noBookings": "You need a booked lesson before submitting homework.",
      "audioRecording": "Audio recording",
      "worksheet": "Worksheet (PDF or image)",
      "uploading": "Uploading…",
      "submit": "Submit homework"
    },
    "submissions": {
      "title": "Your submissions",
      "audio": "Audio",
      "worksheet": "Worksheet",
      "watchVideoFeedback": "Watch tutor video feedback",
      "empty": "Nothing submitted yet."
    },
    "errors": {
      "fileTooLarge": "{{kind}} file must be under 25MB",
      "chooseLesson": "Choose the lesson this homework belongs to",
      "attachFile": "Attach an audio recording or a worksheet",
      "uploadFailed": "Upload failed",
      "openFileFailed": "Could not open file"
    },
    "toasts": {
      "submitted": "Homework submitted — your tutor has been notified"
    }
  },
  "messagesPage": {
    "backToPortal": "Back to portal",
    "title": "Website enquiries",
    "description": "Messages sent through the contact form. Only you can see these.",
    "exportCsv": "Export CSV",
    "loading": "Loading enquiries…",
    "empty": "No enquiries yet.",
    "childAge": "child age {{age}}",
    "status": {
      "handled": "Handled",
      "new": "New"
    },
    "actions": {
      "reopen": "Reopen",
      "markHandled": "Mark handled"
    },
    "csv": {
      "headers": {
        "received": "Received",
        "name": "Name",
        "email": "Email",
        "whatsapp": "WhatsApp",
        "childAge": "Child age",
        "subject": "Subject",
        "message": "Message",
        "status": "Status"
      },
      "filename": "smart-word-labs-enquiries-{{date}}"
    },
    "toasts": {
      "updateFailed": "Couldn't update this enquiry.",
      "nothingToExport": "There are no enquiries to export yet.",
      "exported_one": "Exported {{count}} enquiry.",
      "exported_other": "Exported {{count}} enquiries."
    }
  },
  "admin": {
    "backToDashboard": "Back to dashboard",
    "title": "Admin portal",
    "description": "Payments, bookings, payouts and user accounts for Smart Word Labs.",
    "tabs": {
      "payments": "Payments",
      "bookings": "Bookings",
      "payouts": "Payouts",
      "users": "Users"
    },
    "table": {
      "loading": "Loading…",
      "clearFilters": "Clear filters",
      "details": "Details",
      "view": "View",
      "action": "Action"
    },
    "payments": {
      "searchPlaceholder": "Search student or tutor",
      "searchAriaLabel": "Search payments by student or tutor name",
      "filterAriaLabel": "Filter by payment status",
      "filterPlaceholder": "Payment status",
      "statuses": {
        "all": "All payment statuses",
        "unpaid": "Unpaid",
        "paid": "Paid",
        "refunded": "Refunded"
      },
      "columns": {
        "student": "Student",
        "tutor": "Tutor",
        "programme": "Programme",
        "amount": "Amount",
        "payment": "Payment",
        "created": "Created"
      },
      "empty": "No payments match these filters yet.",
      "refund": "Refund",
      "confirm": {
        "title": "Refund this payment?",
        "description": "This issues a real refund through Stripe for <strong>{{name}}</strong> ({{amount}}) and marks the booking as refunded. It cannot be undone.",
        "fallbackName": "this student",
        "cancel": "Cancel",
        "confirm": "Refund payment"
      },
      "toasts": {
        "success": "Refund issued and the booking is now marked refunded.",
        "error": "The refund could not be completed."
      }
    },
    "bookings": {
      "status": "Status",
      "from": "From",
      "to": "To",
      "statuses": {
        "all": "All statuses",
        "pending": "Pending",
        "confirmed": "Confirmed",
        "completed": "Completed",
        "canceled": "Canceled"
      },
      "columns": {
        "scheduled": "Scheduled",
        "student": "Student",
        "tutor": "Tutor",
        "programme": "Programme",
        "status": "Status",
        "payment": "Payment"
      },
      "empty": "No bookings match these filters yet.",
      "detail": {
        "title": "Booking details",
        "description": "Full record for this lesson booking.",
        "student": "Student",
        "studentEmail": "Student email",
        "tutor": "Tutor",
        "programme": "Programme",
        "amount": "Amount",
        "scheduled": "Scheduled",
        "created": "Created",
        "status": "Status",
        "payment": "Payment",
        "refundedAt": "Refunded at",
        "meetingLink": "Meeting link",
        "stripePayment": "Stripe payment"
      }
    },
    "payouts": {
      "totalPending": "Total pending payouts",
      "filterAriaLabel": "Filter payouts by status",
      "filterPlaceholder": "Status",
      "statuses": {
        "all": "All statuses",
        "pending": "Pending",
        "paid": "Paid"
      },
      "columns": {
        "tutor": "Tutor",
        "amount": "Amount",
        "payoutDate": "Payout date",
        "status": "Status"
      },
      "empty": "No payouts recorded yet.",
      "markAsPaid": "Mark as paid",
      "toasts": {
        "success": "Payout marked as paid.",
        "error": "Couldn't update this payout."
      }
    },
    "users": {
      "filterAriaLabel": "Filter users by role",
      "filterPlaceholder": "Role",
      "roles": {
        "all": "All roles",
        "parent": "Parent",
        "tutor": "Tutor",
        "admin": "Admin"
      },
      "columns": {
        "name": "Name",
        "email": "Email",
        "role": "Role",
        "joined": "Joined"
      },
      "empty": "No users match this filter.",
      "viewTutor": "View tutor",
      "tutorFallback": "Tutor",
      "loadingTutor": "Loading tutor details…",
      "noTutorProfile": "No tutor profile on record.",
      "detail": {
        "hourlyRate": "Hourly rate",
        "commission": "Commission",
        "active": "Active",
        "onboardingSubmitted": "Onboarding submitted",
        "specialisation": "Specialisation",
        "bio": "Bio",
        "yes": "Yes",
        "no": "No"
      }
    }
  }
}
